// change this to set the current project
const currentProject = "pestalozzi";
// const currentProject = "amsel";
// const currentProject = "sophienstrasse";

// export const requestURL = "http://localhost:8080"; // DEV
//export const requestURL = "http://marvin.l-host.net:8808/api/v2/request"; // DEV
export const requestURL = "https://unreal.home-klick.dev/api/v2/request";

// export const unrealAddress = "wss://"; // DEV
export const unrealAddress = "wss://signalling-client.ragnarok.arcware.cloud/";

const projects = {
	pestalozzi: {
		apiAddress: "https://unreal.home-klick.dev/api/v2/init?unit=",
		packageId: "154ff849-f787-4f37-b479-76253341b0ea",
		assets: "pesta",
		metaTitle:
			"Konfigurator für Sonderwünsche - Bordeaux - Pestalozzistraße 11, 10625 Berlin",
		metaDescription:
			"Toplage in Berlin-Charlottenburg, 42 Wohnungen und 4 Gewerbeeinheiten, Ca. 30 qm - 274 qm, Kernsanierter Altbau, DG-Wohnungen mit Roof-Top-Terrassen, Facettenreiche Grundrisse mit 1-bis 6-Zimmern, Balkone bzw. Terrassen, Aufzüge, Privatgärten, Optionales Möblierungskonzept",
		metaImage:
			"https://pestalozzi11.de/wp-content/uploads/2021/11/finall7_web.jpg",
		metaURL: "https://pestalozzi11.de/",
		metaDomain: "pestalozzi11.de",
		icon32:
			"https://pestalozzi11.de/wp-content/uploads/2021/11/cropped-favicon-32x32.png",
		appleTouchIcon:
			"https://pestalozzi11.de/wp-content/uploads/2021/11/cropped-favicon-180x180.png",
		googleTrackingID: "UA-213549017-1",
	},
	amsel: {
		apiAddress: "https://unreal.home-klick.dev/api/v2/init?unit=AMS004-",
		packageId: "093b3650-6bc1-471f-945d-5af202e8313a",
		assets: "amsel",
		metaTitle: "Konfigurator für Sonderwünsche - Amselstraße 4, 14195 Berlin",
		metaDescription:
			"Projekt FINE LIVING Großstädter genießen hier die ganze Bandbreite an Möglichkeiten",
		metaImage:
			"https://amsel04.de/wp-content/uploads/2021/04/Amselstrasse_Exterior_Strassenansicht.jpg",
		metaURL: "https://amsel04.de/",
		metaDomain: "amsel04.de",
		icon32: "https://amsel04.de/wp-content/uploads/fbrfg/favicon-32x32.png",
		appleTouchIcon:
			"https://amsel04.de/wp-content/uploads/fbrfg/apple-touch-icon.png",
		googleTrackingID: "UA-194717432-1",
	},
	sophienstrasse: {
		apiAddress: "https://unreal.home-klick.dev/api/v2/init?unit=SOP034-",
		packageId: "abfb6428-16a1-468c-89e4-47af805c92f1",
		assets: "soph",
		metaTitle:
			"Konfigurator für Sonderwünsche - Vivienne - Sophienstraße 34, 10178 Berlin",
		metaDescription:
			"Sophienstraße 34, 17 provisionsfreie Eigentumswohnungen in Berlin Mitte, direkt vom Bauträger",
		metaImage:
			"https://sop034.berlin/wp-content/uploads/2021/01/Vivienne-Logo-e1611853606309.png",
		metaURL: "https://sop034.berlin/",
		metaDomain: "sop034.berlin",
		icon32: "https://sop034.berlin/wp-content/uploads/fbrfg/favicon-32x32.png",
		appleTouchIcon:
			"https://sop034.berlin/wp-content/uploads/fbrfg/apple-touch-icon.png",
		googleTrackingID: "UA-190815648-1",
	},
};
import("./css/base.css");
import(`./assets/${projects[currentProject].assets}/css/main.css`);

export default projects[currentProject];
